export default [
  {
    path: '/Login',
    component: () => import('@/views/Login'),
  },
  {
    path: "/404",
    component: ()=>import('@/views/Layout'),
    children: [
      {
        path: "/404",
        component: ()=>import('@/components/404/spaceman-index'),
      }
    ],
  },
  {
    path: "/:catchAll(.*)",
    redirect: '/404'
  },
]